const LowOfJusticedata = [
    {
        id : "1",
        schemeName: "Establishing Gram Nyayalayas by the State Governments -Revised General Guidelines",
        discription:"Establishing Gram Nyayalayas by the State Governments -Revised General Guidelines for Central assistance to be provided to the States/UTs . ",
        launchDate: "6 july 2022",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Centrally Sponsored Scheme (CSS)",
    discription:"This Centrally Sponsored Scheme was introduced in 2000 by the then-prime minister of India Atal Bihari Vajpayee. Implementation of Centrally Sponsored Scheme (CSS) for the Development of Infrastructure Facilities for the Judiciary -Revision of guidelines Centrally Sponsored Scheme (CSS)",
    launchDate: "15 August 2000",
    AnualFund: "12345"},
]

export default LowOfJusticedata;